module.exports = __webpack_public_path__ + "img/Subtract.843011c7.svg";